// Package

import { Swiper, SwiperSlide } from 'swiper/react';
import React, { useState, } from 'react';

// import VanillaTilt from 'vanilla-tilt';
// import Lenis from 'lenis'
// import SplitType from 'split-type';
import { gsap } from 'gsap';
// import gsap, { Power2 } from 'gsap';
// import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// videos
// import herovideo from 'assets/video/hero.mp4'


import { Navigation, Autoplay } from 'swiper/modules';

import Header from "../component/header";
import Footer from "../component/footer";
import ContactForm from "../component/contac-form"
import { Portfolio } from "../component/portfoli";
// import NewHome from '../pages/new-home'

import useGsapAnimations from '../component/useGsapAnimations';

// import AnimatedText from "../component/animation";
// import FadeInOnScroll from "../component/scrollanimation";\


import icon03 from "../assets/mystraworks/icons/65bc8a02a87ce72dc15f0c90_ui.svg"
import icon04 from "../assets/mystraworks/icons/65bc8a2da047a0e46256d596_devops.svg"
import icon06 from "../assets/mystraworks/icons/65bc8a585eb9d1ccec38d0b9_maintenance.svg"
import icon05 from "../assets/mystraworks/icons/65bc8a7756c1c240639ef640_seo.svg"
import icon01 from "../assets/mystraworks/icons/65bc87c1fa8bea8e2a0c810d_strategy.svg"
import icon02 from "../assets/mystraworks/icons/65bc8748eb828309c8d2a17a_web.svg"



const servicesData1 = [
  {
    id: "w-dropdown-toggle-0",
    title: "UI/UX Design",
    text: "We crafts seamless digital experiences through intuitive, human-centered UI/UX design, creating meaningful connections between users and your powerful brand.",
    img: icon01,
  },
  {
    id: "w-dropdown-toggle-1",
    title: "Website Development",
    text: "Ready to amplify your brand? We design and develop stunning, mobile-optimized websites that captivate, convert, and drive business growth.",
    img: icon02,
  },
  {
    id: "w-dropdown-toggle-2",
    title: "Web and Mobile App Development",
    text: "Building impactful mobile and web applications for startups and enterprises. We turn your ideas into powerful, scalable, and user-friendly solutions.",
    img: icon03,
  },

];

const servicesData2 = [
  {
    id: "w-dropdown-toggle-5",
    title: "AI Powered Automation",
    text: "Unleash Ally, our AI agent, to automate repetitive tasks. Free your team for high-value work, from lead generation to customer engagement.",
    img: icon04,
  },
  {
    id: "w-dropdown-toggle-3",
    title: "Digital Marketing",
    text: "Amplify your online presence. Our SEO and ad experts optimize your website to rank higher, driving organic traffic and maximizing your ROI.",
    img: icon05,
  },
  {
    id: "w-dropdown-toggle-4",
    title: "Maintenance & Upgrades",
    text: "Boost your business with a high-performance website. Our expert Bangalore web development team ensures peak condition and an exceptional user experience.",
    img: icon06,
  },
  
];



gsap.registerPlugin(ScrollTrigger);
function Home() {
  const [activeId, setActiveId] = useState(null);
 useGsapAnimations();



//     const tiltRef = useRef(null);
//     const allyRef = useRef(null);


//   useEffect(() => {
//     if (tiltRef.current) {
//       VanillaTilt.init(tiltRef.current, {
//         max: 25,
//         speed: 400,
//         glare: true,
//         "max-glare": 0.5,
//       });
//     }

//     if (allyRef.current) {
//       VanillaTilt.init(allyRef.current, {
//         max: 15,
//         speed: 1000,
//         scale: 1.03,
//         glare: true,
//         "max-glare": 0.2,
//         fullPageListening: true, 
//       });
//     }

//     return () => {
//       if (tiltRef.current?.vanillaTilt) {
//         tiltRef.current.vanillaTilt.destroy();
//       }

//        if (allyRef.current?.vanillaTilt) {
//         allyRef.current.vanillaTilt.destroy();
//       }
//     };
//   }, []);




  

    return (
<main>
   <Header/>

    <div id="smooth-wrapper">
     
        <div id="smooth-content">

            {/* <!-- Add your site or application content here --> */}
            <main>

                {/* <!-- hero area start  --> */}
                <section className="hero-area section-spacing p-relative fix">
                    {/* <div className="adjust-header-space"></div> */}
                    <div className="hero-area__bg">
                         <video width="320" height="240" playsInline="" crossOrigin="anonymous" data-cursor-text="" data-cursor="-exclusion" muted="true" autoplay="true" loop="true" className="css--1un3bny">
                            <source src="assets/video/hero-section.mp4"/>
                            </video>
                        {/* <img src="assets/img/bg/hero-bg-1.jpg" alt="mystra-home"/> */}
                    </div>
                    <div className="hero__shapes d-none d-md-block">
                        <img className="hero__shape-1" src="assets/img/shapes/star-1.png" alt="mystra-home"/>
                        <img className="hero__shape-2" src="assets/img/shapes/star-2.png" alt="mystra-home"/>
                    </div>
                    <div className="meta-item meta-item-call d-none d-sm-flex">
                        <div className="meta-item__icon">
                            <img src="assets/img/icons/dial-pad.png" alt="mystra-home"/>
                        </div>
                        <div className="meta-item__text">
                            <p><a href="tel:+919036455200">+91 90 364 55200</a></p>
                        </div>
                    </div>
                    {/* <div className="scroll-btn d-none d-sm-flex">
                        <a href="#"><span>SCROLL</span></a>
                    </div> */}
                   
                    <div className="container">
                        <div className="hero-inner p-relative">
                            <div className="row">
                                <div className="col-xl-12 col-lg-12">
                                    <div className="hero__content">
                                      
                                         <div className='heading-hero'>
                                             <h1 className="hero__title animation__char_come small">
                                             Build your <span className="tpl__theme-color">Digital Platform</span>
                                             &nbsp;and <br/>Amplify your <span className="tpl__theme-color">Brand Story</span>
                                        </h1>

     
<a href="/mystra-service">
  <div className="landing_services__section">
      <div className="landing_service__container updot">
        <div className="landing_service__column bdFadeUp">
{servicesData1.map((serviceData1) => (
          <div
            key={serviceData1.id}
             className={`landing_services__wrapper w-dropdown ${
                activeId === serviceData1.id ? "active" : ""
              }`}
            onMouseEnter={() => setActiveId(serviceData1.id)}
            onMouseLeave={() => setActiveId(null)}
          >
            <div className="landing_service__toggle w-dropdown-toggle" id={serviceData1.id}>
              <div className="landing_services__heading">{serviceData1.title}</div>
            </div>

            <nav
              className={`landing_service__dropdown w-dropdown-list ${
                activeId === serviceData1.id ? "open" : ""
              }`}
              aria-labelledby={serviceData1.id}
            >
              <div className="landing_services__text">{serviceData1.text}</div>
              <div className="landing_services__img-wrapper">
                <img
                  src={serviceData1.img}
                  alt={serviceData1.title}
                  className="landing_services__img"
                />
              </div>
            </nav>

            <div className="service_line"></div>
          </div>
        ))}
        </div>
          <div className="landing_service__column bdFadeUp">
{servicesData2.map((serviceData2) => (
          <div
            key={serviceData2.id}
             className={`landing_services__wrapper w-dropdown ${
                activeId === serviceData2.id ? "active" : ""
              }`}
            onMouseEnter={() => setActiveId(serviceData2.id)}
            onMouseLeave={() => setActiveId(null)}
          >
            <div className="landing_service__toggle w-dropdown-toggle" id={serviceData2.id}>
              <div className="landing_services__heading">{serviceData2.title}</div>
            </div>

            <nav
              className={`landing_service__dropdown w-dropdown-list ${
                activeId === serviceData2.id ? "open" : ""
              }`}
              aria-labelledby={serviceData2.id}
            >
              <div className="landing_services__text">{serviceData2.text}</div>
              <div className="landing_services__img-wrapper">
                <img
                  src={serviceData2.img}
                  alt={serviceData2.title}
                  className="landing_services__img"
                />
              </div>
            </nav>

            <div className="service_line"></div>
          </div>
        ))}
        </div>
      </div>
    </div>

</a>
  
                                         </div>

                                      
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <!-- hero area end  --> */}

                {/* <!-- about area start  --> */}
                {/* section-title-spacing */}
                <section className="about-area section-spacing p-relative">
                    <div className="about__shapes">
                        <img className="about-area__shape-1" src="assets/img/shapes/star-1.png" alt="mystra-home"/>
                    </div>
                    <div className="container">
                        <div className="row section-title-spacing ">
                            <div className="col-xl-12">
                                <div className="section__title-wrapper section__title-wrapper-about">
                                    <div className="section__subtitle tpl__item-center text-start">
                                       
                                         {/* <div className="section__subtitle-icon">
                                            <img src="assets/img/shapes/section-title-star.png" alt="mystra-home"/>
                                        </div> */}
                                        <p className="section__subtitle-text">
                                            <img src="assets/img/shapes/section-title-star.png" alt="mystra-home"/> About us
                                        </p>
                                        
                                       
                                    </div>
                                </div>
                            </div>
                        </div>
                      
                        <div className='col-lg-12 col-md-12 float-start '>
                            <h2 className='title-anim'> 
                                We transform businesses by integrating cutting-edge technology with compelling creative work
                            </h2>
                        </div>

                          <div className='col-lg-12 col-md-12 float-start  mb-50'>
                            
                                       <div className='videos-home bdFadeRight'>
 <p className="hero__text large bdFadeUp">  <b className="section__subtitle-text">Strategic Partnership</b><br/> We act as an extension of your team, ensuring our solutions are perfectly aligned with your strategic goals.</p>
 <p className="hero__text large bdFadeUp">  <b className="section__subtitle-text">Data-Driven Execution</b><br/> We leverage data to build technically sound strategies that deliver measurable business impact.</p>
 <p className="hero__text large bdFadeUp">  <b className="section__subtitle-text">Outcome-Driven Delivery</b><br/> Our mission is to build, grow, and automate your success. We succeed when you do.</p>

                            
                        </div>
                        </div>
                    </div>

              
                </section>

                 
                {/* <!-- contact area start  --> */}
                <div className="contact-area pt-55 section-spacing-bottom p-relative">
                    <div className="contact__shapes">
                        <img className="contact-area__shape-1" src="assets/img/shapes/star-1.png" alt="mystra-home"/>
                        <img className="contact-area__shape-2" src="assets/img/shapes/spiral.png" alt="mystra-home"/>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="contact__btn tpl__item-center">
                                    <a href="/mystra-contact" className="circle-btn is-green">
                                        <span className="icon-box"><i className="flaticon-next"></i></span>
                                        <img src="assets/img/icons/contact-btn-text.png" alt="mystra-home"
                                            className="image-text"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- contact area end  --> */}

              


                               {/* <!-- team area start  --> */}
    <section className="team-area section-spacing p-relative"> 
        <div className="team-area__overlay" data-background="assets/img/bg/box-gradient-bg.jpg"></div>

        {/* <div className="container">
               <div className="section__subtitle">
                            <p className="section__subtitle-text">
                                <img src="assets/img/shapes/section-title-star.png" alt="mystra-home"/>  Our Services
                            </p>
                        </div>
            <div className="team__wrapper">
                <div className="team__member bdFadeRight">
                    <span className="member-designation">Design</span>
                    <a href="/mystra-service">
                        <div className="member-name">
                            <span className="first-name">UX/UI </span>
                            <div className="member-image"><img src="assets/img/home/team-1.webp"
                                    alt="mystra-home"/>
                            </div>
                            <span className="last-name">Design</span>
                        </div>
                    </a>
                    <div className="member-details-btn btn_wrapper">
                        <a className="c-button btn-moving" href="/mystra-service">
                            <span className="c-button__border"></span>
                            <span className="c-button__text">Details</span>
                        </a>
                    </div>
                </div>
                <div className="team__member bdFadeRight">
                    <span className="member-designation">Tech. Consulting</span>
                    <a href="/mystra-service">
                        <div className="member-name">
                            <span className="first-name">App</span>
                            <div className="member-image">
                                <img src="assets/img/home/team-2.webp" alt="mystra-home"/>
                            </div>
                            <span className="last-name">Development</span>
                        </div>
                    </a>
                    <div className="member-details-btn btn_wrapper">
                        <a className="c-button btn-moving" href="/mystra-service">
                            <span className="c-button__border"></span>
                            <span className="c-button__text">Details</span>
                        </a>
                    </div>
                </div>
                <div className="team__member bdFadeRight">
                    <span className="member-designation">Social Media</span>
                    <a href="/mystra-service">
                        <div className="member-name">
                            <span className="first-name"> Growth </span>
                            <div className="member-image">
                                <img src="assets/img/home/team-3.webp" alt="mystra-home"/>
                            </div>
                            <span className="last-name">Strategy</span>
                        </div>
                    </a>
                    <div className="member-details-btn btn_wrapper">
                        <a className="c-button btn-moving" href="/mystra-service">
                            <span className="c-button__border"></span>
                            <span className="c-button__text">Details</span>
                        </a>
                    </div>
                </div>
                <div className="team__member bdFadeRight">
                    <span className="member-designation">AI Ally </span>
                    <a href="/mystra-service">
                        <div className="member-name">
                            <span className="first-name">Virtual </span>
                            <div className="member-image">
                                <img src="assets/img/home/team-4.webp" alt="mystra-home"/>
                            </div>
                            <span className="last-name">Assistants</span>
                        </div>
                    </a>
                    <div className="member-details-btn btn_wrapper">
                        <a className="c-button btn-moving" href="/mystra-contact">
                            <span className="c-button__border"></span>
                            <span className="c-button__text">Contact</span>
                        </a>
                    </div>
                </div>
            </div>
        </div> */}

             {/* <div className="container mt-50">
            <div className="row align-items-end g-5 section-title-spacing">
                <div className="col-lg-7">
                    <div className="section__title-wrapper">
                    
                        <h2 className="section__title-main xlarge uppercase title-anim">
                            Delivering real
                            value for our
                            partners
                        </h2>
                    </div>
                </div>
                <div className="col-lg-5">
                    <div className="team__meta-description mb-10">
                         <h3 className="section__title-main xlarge uppercase title-anim">Experience design, growth & Tech</h3>
                        <p className='p-text mt-30'>
                                                We specialize in human-centric customer experiences, from digital product innovation to transformative business models.
                                                We deliver real value working
                                                closely with our clients to achieve
                                                swift and impactful results
                                                through design innovation and
                                                technology. From start-ups to the
                                                world's leading brands, we work
                                                with companies of all shapes and
                                                sizes.</p>
                    </div>
                </div>
            </div>
        </div> */}
        <Portfolio/>
    </section> 
 
              

                   {/* <!-- hero area start  --> */}
                   <section className="hero-3-area p-relative fix ally-background">
                   
                    {/* <div className="area-absolute">
                        <video width="320" height="240" playsInline="" crossOrigin="anonymous" data-cursor-text="" data-cursor="-exclusion" muted="true" autoplay="true" loop="true" className="css--1un3bny">
                            <source src="assets/video/6917375_Motion_Graphics_Motion_Graphic_1280x720.mp4"/>
                        </video>
                    </div> */}
                    <div className="hero-3__shapes">
                        <img className="hero-3__shape-1" src="assets/img/shapes/circle-line.png" alt="mystra-home"/>
                        <img className="hero-3__shape-2" src="assets/img/shapes/plane-flying.png" alt="mystra-home"/>
                        {/* <img className="hero-3__shape-3" src="assets/img/shapes/arrow-down-left.png" alt="mystra-home"/> */}
                    </div>
                    <div className="hero-3__shapes-2 p-relative hero-3_wrapper">
                        {/* ref={allyRef} */}
                        <img   className="hero-3__shape-4 hero-3-item" src="assets/img/ally-big.webp"
                            alt="mystra-home"/>
                    </div>
                    <div className="container">
                        <div className="hero-3__inner p-relative">
                            
                            <div className="row">
                                <div className="col-xl-12">
                                     
                                    <div className="hero-3__content p-relative">
                                       
                                        <h2 className="hero-3__title bd_banner__anim">
                                           Grow your<br/>business 
                                        </h2>
                                        {/* <span className="hero-3__subtitle">Coming Soon!</span> */}
                                          <h2 className="hero-3__title bd_banner__anim Urbanist-light">on <b className='green-text'>WhatsApp</b></h2>

                                          <p className='hero-3__text p-text'>
                                           Boost engagement and streamline communication with Ally—your AI-powered assistant that automates HR, support, and daily tasks, making interactions faster, smarter, and more personal.
                                          </p>
                                        {/* <ul className="hero-3__text p-text">
                                            <li className='font-bold'>Our AI-powered chatbot, Ally, is revolutionizing pre-sales and HR activities. With Ally, you can:</li>
                                           <li className='theme-color-2'><svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.83 5.78972L4.78628 8.00693C5.20476 8.32079 5.7944 8.2591 6.13886 7.86544L12 1.16699" stroke="#63cf90" stroke-width="2" stroke-linecap="round"></path></svg>  Automate Pre-Sales Activities</li>
                                           <li className='theme-color-2'><svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.83 5.78972L4.78628 8.00693C5.20476 8.32079 5.7944 8.2591 6.13886 7.86544L12 1.16699" stroke="#63cf90" stroke-width="2" stroke-linecap="round"></path></svg>  Enhance customer engagement</li>
                                           <li className='theme-color-2'><svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.83 5.78972L4.78628 8.00693C5.20476 8.32079 5.7944 8.2591 6.13886 7.86544L12 1.16699" stroke="#63cf90" stroke-width="2" stroke-linecap="round"></path></svg>  Streamline HR query and engagement processes</li></ul> */}
                                        {/* <div className="hero-3__btn btn_wrapper" >
                                            <a className="c-button btn-moving btn-bg-white" href="/mystra-contact" ref={tiltRef}>
                                                <span className="c-button__border"></span>
                                                <span className="c-button__text" >Contact Us</span>
                                            </a>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    
                </section>
                {/* <!-- hero area end  --> */}

  {/* <!-- testimonial area end  --> */}

                 <div className="testimonial-area primary-bg section-spacing p-relative">
                        <div className="container">
                            <div className="row">

                                 <div className="col-lg-8 mb-50">
                                            <div className="section__title-wrapper section__title-wrapper-services">
                                                <div className="section__subtitle">
                                                    {/* <div className="section__subtitle-icon">
                                                        <img src="assets/img/shapes/section-title-star.png" alt="mystra-home"/>
                                                    </div> */}
                                                    <p className="section__subtitle-text">
                                                        <img src="assets/img/shapes/section-title-star.png" alt="mystra-home"/> Clients Feeback
                                                    </p>
                                                </div>
                                                <h2 className="section__title-main xlarge uppercase title-anim">Have a look to our Clients Feebacks
                                                </h2>
                                            </div>
                                        </div>
                                <div className="col-12">
                                    <div className="testimonia-area p-relative nav-on-hover">
                                        <div className="brand-2-navigation slider-nav-wrapper">
                                            <button className="brand-2-button-prev slider-nav slider-nav-prev"><i
                                                    className="fa-regular fa-arrow-left-long"></i></button>
                                            <button className="brand-2-button-next slider-nav slider-nav-next"><i
                                                    className="fa-regular fa-arrow-right-long"></i></button>
                                        </div>
                                        <div className="swiper-container brand-active-2">
                                            <div className="swiper-wrapper">


                                                 <Swiper
                                                    modules={[Navigation, Autoplay]}
                                                    autoplay={{
                                                    delay: 1000,
                                                    disableOnInteraction: false,
                                                    }}
                                                    loop={true}
                                                    slidesPerView={1}
                                                    navigation={{
                                                    nextEl: '.brand-2-button-next',
                                                    prevEl: '.brand-2-button-prev',
                                                    }}
                                                    breakpoints={{
                                                    640: { slidesPerView: 1 },
                                                    768: { slidesPerView: 2, spaceBetween: 15 },
                                                    1024: { slidesPerView: 3, spaceBetween: 20 },
                                                    }}
                                                    scrollbar={{ draggable: true }}
                                                    onSwiper={(swiper) => console.log(swiper)}
                                                    onSlideChange={() => console.log('slide change')}
                                                >
                                                    {/* Your slides go here */}

                                                      {/* //slide1 */}
                                                <SwiperSlide>
                                                     <div className="swiper-slide">
                                                    <div className="brand-testimonial-item">
                                                        <div className="brand-testimonial-content">
                                                            <div className="brand-testimonial-icon">
                                                                <span>
                                                                    <svg width="40" height="40" viewBox="0 0 40 40"
                                                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path
                                                                            d="M9.83492 18.3628C10.1862 15.6992 12.5408 13.2883 16.8477 11.1873L17.6232 10.809L14.4436 4.93866L13.7258 5.30249C4.61805 9.91928 0 16.4439 0 24.6953C0 27.5423 0.90375 30.0012 2.68633 32.0039C4.49391 34.0344 6.6875 35.0641 9.20664 35.0641C11.4702 35.0641 13.3895 34.258 14.9114 32.6681C16.4234 31.0884 17.19 29.1263 17.19 26.8362C17.19 24.6721 16.4156 22.7435 14.8884 21.104C13.5413 19.6578 11.844 18.7379 9.83492 18.3628ZM13.7164 31.5243C12.5019 32.7931 11.0267 33.4098 9.20664 33.4098C7.15156 33.4098 5.42297 32.5901 3.92211 30.904C2.39602 29.1896 1.65414 27.1587 1.65414 24.6952C1.65414 20.9134 2.71906 17.4991 4.81914 14.5473C6.82297 11.731 9.82844 9.24452 13.7598 7.14889L15.3527 10.0897C10.562 12.6001 8.13476 15.618 8.13476 19.0681V19.8069L8.86875 19.89C10.8459 20.1138 12.4188 20.8797 13.678 22.2314C14.928 23.5734 15.5358 25.0798 15.5358 26.8361C15.5359 28.7117 14.9406 30.2451 13.7164 31.5243Z"
                                                                            fill="#14CF93" />
                                                                        <path
                                                                            d="M32.2817 18.3653C32.6288 15.6995 34.964 13.2873 39.2363 11.1861L40 10.8106L36.8994 4.93604L36.1745 5.30182C27.0251 9.91838 22.386 16.4433 22.386 24.6953C22.386 27.5442 23.3013 30.0044 25.1064 32.0076C26.934 34.0356 29.1366 35.064 31.6538 35.064C33.9201 35.064 35.8306 34.2564 37.3323 32.6636C38.821 31.0846 39.5759 29.1239 39.5759 26.8361C39.5759 24.672 38.8016 22.7434 37.2745 21.1039C35.9302 19.6609 34.2533 18.7417 32.2817 18.3653ZM36.1288 31.5288C34.9353 32.7946 33.4716 33.4099 31.6538 33.4099C29.5966 33.4099 27.857 32.5891 26.3352 30.9003C24.7908 29.1864 24.0401 27.1568 24.0401 24.6953C24.0401 20.9142 25.1098 17.5004 27.2192 14.5489C29.232 11.7332 32.2504 9.24713 36.1984 7.15174L37.7481 10.088C32.992 12.5993 30.5821 15.6178 30.5821 19.0682V19.8053L31.3142 19.8899C33.2508 20.1134 34.8044 20.8793 36.0641 22.2315C37.3142 23.5735 37.9218 25.0796 37.9218 26.8362C37.9219 28.7142 37.3353 30.2492 36.1288 31.5288Z"
                                                                            fill="#14CF93" />
                                                                    </svg>
                                                                </span>
                                                            </div>
                                                            <p>The entire process with Mystra Tech was refreshingly transparent. Their open communication and streamlined workflow made a complex project feel effortless. They are a truly reliable and professional team.</p>
                                                        </div>
                                                        <div className="testimonial-author">
                                                            <h4>Avenash</h4>
                                                            <p> CEO, ArknEngineering Pvt Ltd</p>
                                                        </div>
                                                    </div>
                                                </div>

                                                </SwiperSlide>
                                                  
                                                 {/* //slide2 */} 
                                                <SwiperSlide>
                                                     <div className="swiper-slide">
                                                    <div className="brand-testimonial-item">
                                                        <div className="brand-testimonial-content">
                                                            <div className="brand-testimonial-icon">
                                                                <span>
                                                                    <svg width="40" height="40" viewBox="0 0 40 40"
                                                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path
                                                                            d="M9.83492 18.3628C10.1862 15.6992 12.5408 13.2883 16.8477 11.1873L17.6232 10.809L14.4436 4.93866L13.7258 5.30249C4.61805 9.91928 0 16.4439 0 24.6953C0 27.5423 0.90375 30.0012 2.68633 32.0039C4.49391 34.0344 6.6875 35.0641 9.20664 35.0641C11.4702 35.0641 13.3895 34.258 14.9114 32.6681C16.4234 31.0884 17.19 29.1263 17.19 26.8362C17.19 24.6721 16.4156 22.7435 14.8884 21.104C13.5413 19.6578 11.844 18.7379 9.83492 18.3628ZM13.7164 31.5243C12.5019 32.7931 11.0267 33.4098 9.20664 33.4098C7.15156 33.4098 5.42297 32.5901 3.92211 30.904C2.39602 29.1896 1.65414 27.1587 1.65414 24.6952C1.65414 20.9134 2.71906 17.4991 4.81914 14.5473C6.82297 11.731 9.82844 9.24452 13.7598 7.14889L15.3527 10.0897C10.562 12.6001 8.13476 15.618 8.13476 19.0681V19.8069L8.86875 19.89C10.8459 20.1138 12.4188 20.8797 13.678 22.2314C14.928 23.5734 15.5358 25.0798 15.5358 26.8361C15.5359 28.7117 14.9406 30.2451 13.7164 31.5243Z"
                                                                            fill="#14CF93" />
                                                                        <path
                                                                            d="M32.2817 18.3653C32.6288 15.6995 34.964 13.2873 39.2363 11.1861L40 10.8106L36.8994 4.93604L36.1745 5.30182C27.0251 9.91838 22.386 16.4433 22.386 24.6953C22.386 27.5442 23.3013 30.0044 25.1064 32.0076C26.934 34.0356 29.1366 35.064 31.6538 35.064C33.9201 35.064 35.8306 34.2564 37.3323 32.6636C38.821 31.0846 39.5759 29.1239 39.5759 26.8361C39.5759 24.672 38.8016 22.7434 37.2745 21.1039C35.9302 19.6609 34.2533 18.7417 32.2817 18.3653ZM36.1288 31.5288C34.9353 32.7946 33.4716 33.4099 31.6538 33.4099C29.5966 33.4099 27.857 32.5891 26.3352 30.9003C24.7908 29.1864 24.0401 27.1568 24.0401 24.6953C24.0401 20.9142 25.1098 17.5004 27.2192 14.5489C29.232 11.7332 32.2504 9.24713 36.1984 7.15174L37.7481 10.088C32.992 12.5993 30.5821 15.6178 30.5821 19.0682V19.8053L31.3142 19.8899C33.2508 20.1134 34.8044 20.8793 36.0641 22.2315C37.3142 23.5735 37.9218 25.0796 37.9218 26.8362C37.9219 28.7142 37.3353 30.2492 36.1288 31.5288Z"
                                                                            fill="#14CF93" />
                                                                    </svg>
                                                                </span>
                                                            </div>
                                                            <p>Working with Mystra Tech was phenomenal. Their team’s dedication and transparency are unmatched. They didn’t just build a product; they became a vital part of our team.</p>
                                                        </div>
                                                        <div className="testimonial-author">
                                                            <h4>Krishna Kumar GM</h4>
                                                            <p>Sales Head, Indus Engineering</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                </SwiperSlide>
                                               
                                               {/* //slide3 */}
                                                <SwiperSlide> 
                                                   <div className="swiper-slide">
                                                    <div className="brand-testimonial-item">
                                                        <div className="brand-testimonial-content">
                                                            <div className="brand-testimonial-icon">
                                                                <span>
                                                                    <svg width="40" height="40" viewBox="0 0 40 40"
                                                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path
                                                                            d="M9.83492 18.3628C10.1862 15.6992 12.5408 13.2883 16.8477 11.1873L17.6232 10.809L14.4436 4.93866L13.7258 5.30249C4.61805 9.91928 0 16.4439 0 24.6953C0 27.5423 0.90375 30.0012 2.68633 32.0039C4.49391 34.0344 6.6875 35.0641 9.20664 35.0641C11.4702 35.0641 13.3895 34.258 14.9114 32.6681C16.4234 31.0884 17.19 29.1263 17.19 26.8362C17.19 24.6721 16.4156 22.7435 14.8884 21.104C13.5413 19.6578 11.844 18.7379 9.83492 18.3628ZM13.7164 31.5243C12.5019 32.7931 11.0267 33.4098 9.20664 33.4098C7.15156 33.4098 5.42297 32.5901 3.92211 30.904C2.39602 29.1896 1.65414 27.1587 1.65414 24.6952C1.65414 20.9134 2.71906 17.4991 4.81914 14.5473C6.82297 11.731 9.82844 9.24452 13.7598 7.14889L15.3527 10.0897C10.562 12.6001 8.13476 15.618 8.13476 19.0681V19.8069L8.86875 19.89C10.8459 20.1138 12.4188 20.8797 13.678 22.2314C14.928 23.5734 15.5358 25.0798 15.5358 26.8361C15.5359 28.7117 14.9406 30.2451 13.7164 31.5243Z"
                                                                            fill="#14CF93" />
                                                                        <path
                                                                            d="M32.2817 18.3653C32.6288 15.6995 34.964 13.2873 39.2363 11.1861L40 10.8106L36.8994 4.93604L36.1745 5.30182C27.0251 9.91838 22.386 16.4433 22.386 24.6953C22.386 27.5442 23.3013 30.0044 25.1064 32.0076C26.934 34.0356 29.1366 35.064 31.6538 35.064C33.9201 35.064 35.8306 34.2564 37.3323 32.6636C38.821 31.0846 39.5759 29.1239 39.5759 26.8361C39.5759 24.672 38.8016 22.7434 37.2745 21.1039C35.9302 19.6609 34.2533 18.7417 32.2817 18.3653ZM36.1288 31.5288C34.9353 32.7946 33.4716 33.4099 31.6538 33.4099C29.5966 33.4099 27.857 32.5891 26.3352 30.9003C24.7908 29.1864 24.0401 27.1568 24.0401 24.6953C24.0401 20.9142 25.1098 17.5004 27.2192 14.5489C29.232 11.7332 32.2504 9.24713 36.1984 7.15174L37.7481 10.088C32.992 12.5993 30.5821 15.6178 30.5821 19.0682V19.8053L31.3142 19.8899C33.2508 20.1134 34.8044 20.8793 36.0641 22.2315C37.3142 23.5735 37.9218 25.0796 37.9218 26.8362C37.9219 28.7142 37.3353 30.2492 36.1288 31.5288Z"
                                                                            fill="#14CF93" />
                                                                    </svg>
                                                                </span>
                                                            </div>
                                                            <p>Mystra Tech's professional work ethic is fantastic. They understood our vision, communicated transparently, and delivered a robust platform that was absolutely critical for our launch and subsequent growth.</p>
                                                        </div>
                                                        <div className="testimonial-author">
                                                            <h4>Michael</h4>
                                                            <p>Head of Operations, Musterguard</p>
                                                        </div>
                                                    </div>
                                                </div>

                                                </SwiperSlide>
                                                
                                                {/* //slide4 */}
                                                <SwiperSlide> 
                                                 <div className="swiper-slide">
                                                    <div className="brand-testimonial-item">
                                                        <div className="brand-testimonial-content">
                                                            <div className="brand-testimonial-icon">
                                                                <span>
                                                                    <svg width="40" height="40" viewBox="0 0 40 40"
                                                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path
                                                                            d="M9.83492 18.3628C10.1862 15.6992 12.5408 13.2883 16.8477 11.1873L17.6232 10.809L14.4436 4.93866L13.7258 5.30249C4.61805 9.91928 0 16.4439 0 24.6953C0 27.5423 0.90375 30.0012 2.68633 32.0039C4.49391 34.0344 6.6875 35.0641 9.20664 35.0641C11.4702 35.0641 13.3895 34.258 14.9114 32.6681C16.4234 31.0884 17.19 29.1263 17.19 26.8362C17.19 24.6721 16.4156 22.7435 14.8884 21.104C13.5413 19.6578 11.844 18.7379 9.83492 18.3628ZM13.7164 31.5243C12.5019 32.7931 11.0267 33.4098 9.20664 33.4098C7.15156 33.4098 5.42297 32.5901 3.92211 30.904C2.39602 29.1896 1.65414 27.1587 1.65414 24.6952C1.65414 20.9134 2.71906 17.4991 4.81914 14.5473C6.82297 11.731 9.82844 9.24452 13.7598 7.14889L15.3527 10.0897C10.562 12.6001 8.13476 15.618 8.13476 19.0681V19.8069L8.86875 19.89C10.8459 20.1138 12.4188 20.8797 13.678 22.2314C14.928 23.5734 15.5358 25.0798 15.5358 26.8361C15.5359 28.7117 14.9406 30.2451 13.7164 31.5243Z"
                                                                            fill="#14CF93" />
                                                                        <path
                                                                            d="M32.2817 18.3653C32.6288 15.6995 34.964 13.2873 39.2363 11.1861L40 10.8106L36.8994 4.93604L36.1745 5.30182C27.0251 9.91838 22.386 16.4433 22.386 24.6953C22.386 27.5442 23.3013 30.0044 25.1064 32.0076C26.934 34.0356 29.1366 35.064 31.6538 35.064C33.9201 35.064 35.8306 34.2564 37.3323 32.6636C38.821 31.0846 39.5759 29.1239 39.5759 26.8361C39.5759 24.672 38.8016 22.7434 37.2745 21.1039C35.9302 19.6609 34.2533 18.7417 32.2817 18.3653ZM36.1288 31.5288C34.9353 32.7946 33.4716 33.4099 31.6538 33.4099C29.5966 33.4099 27.857 32.5891 26.3352 30.9003C24.7908 29.1864 24.0401 27.1568 24.0401 24.6953C24.0401 20.9142 25.1098 17.5004 27.2192 14.5489C29.232 11.7332 32.2504 9.24713 36.1984 7.15174L37.7481 10.088C32.992 12.5993 30.5821 15.6178 30.5821 19.0682V19.8053L31.3142 19.8899C33.2508 20.1134 34.8044 20.8793 36.0641 22.2315C37.3142 23.5735 37.9218 25.0796 37.9218 26.8362C37.9219 28.7142 37.3353 30.2492 36.1288 31.5288Z"
                                                                            fill="#14CF93" />
                                                                    </svg>
                                                                </span>
                                                            </div>
                                                            <p>Mystra Tech’s commitment is top-notch. Their team’s incredible work ethic and dedication were evident at every stage, delivering results that exceeded our expectations. A fantastic technology partner.</p>
                                                        </div>
                                                        <div className="testimonial-author">
                                                            <h4>Jeffin</h4>
                                                            <p>Founder, Pints</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                </SwiperSlide>
                                                </Swiper>

                                              

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

            
     

            {/* <!-- Contact area start --> */}
              <ContactForm/>
            {/* <!-- Contact area end --> */}

                {/* <!-- link scroll area start  --> */}
              <section className="link-scroll-area p-relative fix pt-55 pb-55 bg-theme-2">
                    <div className="link-scroll-area-shape">
                    </div>
                    <div className="swiper text__scroll">
                        <div className="swiper-wrapper link-scroll-wrapper">
                             <Swiper
                                direction="horizontal"
                                loop={true}
                                speed={20000}
                                autoplay={{
                                    delay: 0,
                                    // reverseDirection: true, // ← scrolls right-to-left
                                    disableOnInteraction: false,
                                }}
                                slidesPerView="auto"
                                modules={[Autoplay]}
                                >

                                    <SwiperSlide>
                            <div className="swiper-slide">
                                <div className="link-scroll-line">
                                    <h2 className="link-scroll-line__heading xlarge uppercase">
                                        <a href="/mystra-contact">Integrate your  <span className="stroke-text"> Business</span></a>&nbsp;
                                        <a href="/mystra-contact">with cutting-edge <span className="stroke-text"> Technology</span></a>&nbsp;
                                        <a href="/mystra-contact">with compelling <span className="stroke-text"> creative work</span></a>&nbsp;
                                    </h2>
                                </div>
                            </div>
                       </SwiperSlide>

                          <SwiperSlide>
                            <div className="swiper-slide">
                                <div className="link-scroll-line">
                                   <h2 className="link-scroll-line__heading xlarge uppercase">
                                        <a href="/mystra-contact">Integrate your  <span className="stroke-text"> Business</span></a>&nbsp;
                                        <a href="/mystra-contact">with cutting-edge <span className="stroke-text"> Technology</span></a>&nbsp;
                                        <a href="/mystra-contact">with compelling <span className="stroke-text"> creative work</span></a>&nbsp;
                                    </h2>
                                </div>
                            </div>
                       </SwiperSlide>
                           
                            <SwiperSlide>
                           <div className="swiper-slide">
                                <div className="link-scroll-line">
                                    <h2 className="link-scroll-line__heading xlarge uppercase">
                                        <a href="/mystra-contact">Integrate your  <span className="stroke-text"> Business</span></a>&nbsp;
                                        <a href="/mystra-contact">with cutting-edge <span className="stroke-text"> Technology</span></a>&nbsp;
                                        <a href="/mystra-contact">with compelling <span className="stroke-text"> creative work</span></a>&nbsp;
                                    </h2>
                                </div>
                            </div>
                            </SwiperSlide>

                                </Swiper>
                       
                            
                        </div>
                    </div>
                </section> 
                {/* <!-- link scroll area end  --> */}
            </main>

            
            {/* <!-- footer-area-start --> */}
              <Footer/>  
            {/* <!-- footer-area-end --> */}
        </div>
    </div>

    {/* <!-- back to top start --> */}
    <div className="progress-wrap">
        <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
            <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
    </div>
    {/* <!-- back to top end --> */}
    </main>
)}

export default Home;